import {
	useBlockProps,
	InnerBlocks,
	InspectorControls,
} from "@wordpress/block-editor";
import { TextControl, PanelBody, PanelRow } from "@wordpress/components";
import { __ } from "@wordpress/i18n";

import "./inner-blocks/command";
import "./inner-blocks/output";
import "./inner-blocks/progress-bar";

import metadata from "./block.json";

export default function edit({ attributes, setAttributes }) {
	const blockProps = useBlockProps();
	const onChangeTitle = (title) => {
		setAttributes({ title });
	};
	return (
		<>
			<InspectorControls>
				<PanelBody
					title={__("Terminal Settings", metadata.textdomain)}
					initialOpen={true}
				>
					<PanelRow>
						<TextControl
							label={__("Title", metadata.textdomain)}
							value={attributes.title}
							onChange={onChangeTitle}
							help={__(
								"Change the title. Defaults to bash",
								metadata.textdomain
							)}
						/>
					</PanelRow>
				</PanelBody>
			</InspectorControls>
			<div {...blockProps} title={attributes.title}>
				<InnerBlocks
					allowedBlocks={[
						"core/spacer",
						"codesue/terminal-command-block",
						"codesue/terminal-output-block",
						"codesue/terminal-progress-bar-block",
					]}
				/>
			</div>
		</>
	);
}
